import { WrittenQuestion } from '../../types';

export const writtenQuestions: WrittenQuestion[] = [
  // Grundsätze (5 Fragen)
  {
    id: 'wq-1',
    question: 'Nenne die 4 Grundsätze der EU.',
    expectedAnswer: '1. Gemeinsame Werte und Ziele (Freiheit, Demokratie, Menschenrechte)\n2. Wirtschaftliche Zusammenarbeit (freier Handel, keine Zölle, Binnenmarkt)\n3. Politische Zusammenarbeit (gemeinsame Regeln, EU-Parlament)\n4. Zusammenhalt in Krisenzeiten (gegenseitige Hilfe bei Katastrophen)',
    maxPoints: 4,
    difficulty: 'pflicht',
    category: 'grundsaetze',
  },
  {
    id: 'wq-2',
    question: 'Erkläre was "Gemeinsame Werte und Ziele" als EU-Grundsatz bedeutet.',
    expectedAnswer: 'Die EU-Länder teilen gemeinsame Werte wie Freiheit, Demokratie und Menschenrechte. Die Ziele sind Frieden, Wohlstand und Wirtschaftswachstum für alle Mitgliedsländer.',
    maxPoints: 3,
    difficulty: 'pflicht',
    category: 'grundsaetze',
  },
  {
    id: 'wq-3',
    question: 'Erkläre was "Wirtschaftliche Zusammenarbeit" als EU-Grundsatz bedeutet.',
    expectedAnswer: 'Waren, Geld und Personen können sich frei über die Grenzen bewegen. Es gibt keine Zölle zwischen EU-Ländern. Der gemeinsame Binnenmarkt funktioniert wie ein großes Land.',
    maxPoints: 3,
    difficulty: 'pflicht',
    category: 'grundsaetze',
  },
  {
    id: 'wq-4',
    question: 'Erkläre was "Politische Zusammenarbeit" als EU-Grundsatz bedeutet.',
    expectedAnswer: 'Die EU-Länder haben gemeinsame Regeln und Gesetze, die für alle gelten. Diese werden vom Europäischen Parlament festgelegt. Die Länder arbeiten politisch zusammen.',
    maxPoints: 3,
    difficulty: 'pflicht',
    category: 'grundsaetze',
  },
  {
    id: 'wq-5',
    question: 'Erkläre was "Zusammenhalt in Krisenzeiten" als EU-Grundsatz bedeutet.',
    expectedAnswer: 'Bei Naturkatastrophen oder Krieg halten die EU-Länder zusammen und unterstützen sich gegenseitig. Die EU hilft Mitgliedsländern in Notsituationen.',
    maxPoints: 2,
    difficulty: 'pflicht',
    category: 'grundsaetze',
  },

  // Vorteile und Nachteile (4 Fragen)
  {
    id: 'wq-6',
    question: 'Nenne 3 Vorteile der EU.',
    expectedAnswer: '1. Freies Reisen und Arbeiten (ohne Visum in anderen EU-Ländern leben)\n2. Gemeinsame Währung Euro (20 Länder, einfacherer Handel)\n3. Frieden und Stabilität (kein Krieg zwischen EU-Ländern seit Jahrzehnten)\n4. Binnenmarkt (großer Markt ohne Grenzen)\n5. Menschenrechte (hohe Standards für Demokratie)',
    maxPoints: 3,
    difficulty: 'pflicht',
    category: 'vorteile',
  },
  {
    id: 'wq-7',
    question: 'Nenne die 3 Nachteile der EU.',
    expectedAnswer: '1. Bürokratie (komplexe Strukturen, Entscheidungen dauern lange)\n2. Souveränitätsverlust (Länder geben Entscheidungsmacht an EU ab)\n3. Ungleiche wirtschaftliche Entwicklung (manche Länder reicher als andere)',
    maxPoints: 3,
    difficulty: 'pflicht',
    category: 'nachteile',
  },
  {
    id: 'wq-8',
    question: 'Erkläre was "Souveränitätsverlust" als EU-Nachteil bedeutet.',
    expectedAnswer: 'Souveränitätsverlust bedeutet, dass die EU-Länder einen Teil ihrer eigenen Entscheidungsmacht an die EU abgeben müssen. Sie können nicht mehr alles alleine bestimmen, sondern müssen sich an EU-Regeln halten.',
    maxPoints: 2,
    difficulty: 'pflicht',
    category: 'nachteile',
  },
  {
    id: 'wq-9',
    question: 'Erkläre was "Bürokratie" als EU-Nachteil bedeutet.',
    expectedAnswer: 'Die EU hat komplexe Strukturen mit vielen verschiedenen Institutionen. Entscheidungen dauern oft sehr lange, weil viele Ebenen mitreden müssen. Es gibt viele Regeln und Vorschriften.',
    maxPoints: 2,
    difficulty: 'pflicht',
    category: 'nachteile',
  },

  // Geschichte/Aufgaben (4 Fragen)
  {
    id: 'wq-10',
    question: 'Warum wurde die EGKS 1951 gegründet?',
    expectedAnswer: 'Die EGKS (Europäische Gemeinschaft für Kohle und Stahl) wurde gegründet, damit die Ressourcen Kohle und Stahl nicht mehr für Kriege verwendet werden. Das Ziel war Friedenssicherung nach dem Zweiten Weltkrieg.',
    maxPoints: 2,
    difficulty: 'pflicht',
    category: 'geschichte',
  },
  {
    id: 'wq-11',
    question: 'Welche 6 Länder gründeten die EGKS?',
    expectedAnswer: 'Belgien, Deutschland, Frankreich, Italien, Luxemburg und die Niederlande. Diese 6 Länder sind die Gründerstaaten der späteren EU.',
    maxPoints: 6,
    difficulty: 'pflicht',
    category: 'geschichte',
  },
  {
    id: 'wq-12',
    question: 'Wann und durch welchen Vertrag wurde die EU gegründet?',
    expectedAnswer: 'Die EU wurde 1993 durch den Vertrag von Maastricht gegründet.',
    maxPoints: 2,
    difficulty: 'pflicht',
    category: 'geschichte',
  },
  {
    id: 'wq-13',
    question: 'Was war das Ziel der EWG 1957?',
    expectedAnswer: 'Das Ziel der EWG (Europäische Wirtschaftsgemeinschaft) war es, einen gemeinsamen Markt zu schaffen. Die Mitgliedsländer sollten frei miteinander handeln können ohne Zölle.',
    maxPoints: 2,
    difficulty: 'pflicht',
    category: 'geschichte',
  },

  // Abkürzungen und Regionen (2 Fragen)
  {
    id: 'wq-14',
    question: 'Wofür stehen die Abkürzungen EGKS, EWG und Euratom?',
    expectedAnswer: 'EGKS = Europäische Gemeinschaft für Kohle und Stahl (gegründet 1951)\nEWG = Europäische Wirtschaftsgemeinschaft (gegründet 1957)\nEuratom = Europäische Atomgemeinschaft (gegründet 1957)',
    maxPoints: 3,
    difficulty: 'pflicht',
    category: 'abkuerzungen',
  },
  {
    id: 'wq-15',
    question: 'Nenne die 6 EU-Regionen mit je einem Beispielland.',
    expectedAnswer: '1. Mitteleuropa (z.B. Österreich, Deutschland)\n2. Westeuropa (z.B. Frankreich, Belgien)\n3. Nordeuropa (z.B. Schweden, Finnland)\n4. Südeuropa (z.B. Italien, Spanien)\n5. Baltikum (z.B. Estland, Lettland)\n6. Südosteuropa (z.B. Rumänien, Bulgarien)',
    maxPoints: 6,
    difficulty: 'pflicht',
    category: 'regionen',
  },
  {
    id: 'wq-16',
    question: 'Wie viele EU-Mitgliedsländer nutzen den Euro und was ist ein Hauptvorteil dieser gemeinsamen Währung?',
    expectedAnswer: '20 EU-Mitgliedsländer nutzen den Euro. Ein Hauptvorteil ist, dass der Handel und das Reisen zwischen den Euroländern einfacher wird, weil man kein Geld mehr wechseln muss. Der Euro schafft Vertrauen bei Bürgern und Investoren.',
    maxPoints: 3,
    difficulty: 'pflicht',
    category: 'vorteile',
  },
];
